<template>
  <div class="fccRelatorios">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage" />
      <form class="d-flex align-items-center" @submit.prevent="BuscaCampos">
        <v-select
          placeholder="Selecione o Relatório"
          label="objnome"
          v-model="relatorioItens"
          :class="relatorioItens.objspi ? 'w-50' : 'w-75'"
          :options="listarRelatorio"
          :clearable="false"
        >
          <template #search="{ attributes, events }">
            <input
              class="vs__search"
              :required="!relatorioItens"
              v-bind="attributes"
              v-on="events"
            />
          </template>
        </v-select>

        <input v-model="relatorioItens.objview" type="hidden" />

        <div class="ml-3 w-25" v-if="relatorioItens.objspi">
          <label>SPI<span class="text-danger">*</span>:</label>
          <fccSpi class="d-inline-block ml-2 w-75" v-model="spi"></fccSpi>
        </div>

        <fcc-button class="ml-3" tipo="submit">{{ labelsSystem.buscar }}</fcc-button>
      </form>

      <div v-show="relatorioItensSelecionado">
        <hr />

        <h1 class="titlePage text-center">{{ titlePDF }}</h1>
        <fccTable
          striped
          hover
          :optionsButton="optionsButton"
          :fields="fields"
          :porPage="perPage"
          responsive
          :items="listarView"
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="tituloPDF"
          complexFilter
          :complexFilterColumn="listagemColunas"
          @complexFilterSearch="pesquisarRelatorio"
          ref="fccTable"
        ></fccTable>
      </div>
    </div>

    <fccModal
      centered
      idModal="ordenarCampos"
      titleModal="Ordenar Campos"
      size="lg"
      escondeFooter
      travaEsc
      travaBack
    >
      <div v-for="ordernando in listandoOrder" :key="ordernando.id">
        <b-row class="opcoesModal my-1">
          <b-col cols="5">
            <v-select
              :options="listagemColunas"
              v-model="ordernando.campo"
              placeholder="Selecione o Campo"
              label="columnname"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!ordernando.campo"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </b-col>
          <b-col cols="5">
            <v-select
              :options="listagemOrder"
              placeholder="Selecione o Critério"
              v-model="ordernando.tipo"
              label="nome"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!ordernando.tipo"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </b-col>
          <b-col>
            <div class="buttonAdd">
              <button @click="removeFiltroOrder(ordernando)" type="button">
                <font-awesome-icon icon="times" size="lg" />
              </button>
            </div>
          </b-col>
        </b-row>
      </div>

      <hr v-if="listandoOrder.length > 0" />

      <form @submit.prevent="addOrder" autocomplete="off">
        <b-row class="opcoesModal">
          <b-col cols="5">
            <v-select
              :options="listagemColunas"
              v-model="orderCampo.campo"
              placeholder="Selecione o Campo"
              label="columnname"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!orderCampo.campo"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </b-col>
          <b-col cols="5">
            <v-select
              :options="listagemOrder"
              placeholder="Selecione o Critério"
              v-model="orderCampo.tipo"
              label="nome"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!orderCampo.tipo"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </b-col>
          <b-col>
            <div class="buttonAdd">
              <button type="submit">
                <font-awesome-icon icon="plus" size="lg" />
              </button>
            </div>
          </b-col>
        </b-row>
      </form>
      <div v-if="listandoOrder.length >= 1">
        <hr />
        <b-row>
          <b-col class="text-right">
            <button class="btn btn-primary" @click="pesquisarRelatorioOrdem" type="button">
              {{ labelsSystem.buscar }}
            </button>
          </b-col>
        </b-row>
      </div>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import './assets/sass/fccRelatorios.scss'

export default {
  data() {
    return {
      listaInt: [
        'INT',
        'TINYINT',
        'BIT',
        'BIGINT',
        'DECIMAL',
        'NUMERIC',
        'SMALLMONEY',
        'MONEY',
        'FLOAT',
        'REAL'
      ],
      sortBy: 'ordem',
      titlePage: 'Relatórios',
      titlePDF: '',
      baseUrlRelatorios: '',
      parametros: '',
      listarRelatorio: [],
      relatorioItens: '',
      relatorioItensSelecionado: false,
      baseAplicacao: store.state.baseUrlAplicacao,
      listagemColunas: [],
      listandoOrder: [],
      filtroCondicaoCache: [],
      listarView: [],
      orderCampo: {
        campo: '',
        tipo: ''
      },
      listagemOrder: [
        { nome: 'Crescente', valor: 'ASC' },
        { nome: 'Decrescente', valor: 'DESC' }
      ],
      optionsButton: [
        {
          funcaoButton: 'ordenarCampos',
          tooltip: 'Ordenar',
          icon: 'sort-amount-up-alt'
        }
      ],
      spi: '',
      perPage: '',
      fields: []
    }
  },
  methods: {
    removeFiltroOrder: function (itema) {
      this.listandoOrder = this.listandoOrder.filter((item) => item !== itema)
      this.callToast(this.mensagensUpdate.excluido, 'success')
    },
    ordenarCampos: function () {
      this.$root.$emit('bv::show::modal', 'ordenarCampos')
    },
    addOrder: function () {
      this.listandoOrder.push({
        id: this.listandoOrder.length + 1,
        campo: this.orderCampo.campo,
        tipo: this.orderCampo.tipo
      })
      this.orderCampo = {
        campo: '',
        tipo: ''
      }
      this.callToast(this.mensagensUpdate.adicionado, 'success')
    },
    gerandoFields: function () {
      const fieldsCache = []
      this.listagemColunas.forEach((element) => {
        fieldsCache.push({
          key: element.columnname,
          label: element.columnname,
          sortable: true,
          active: true,
          totalizar: element.indtotal,
          totalizartipo: element.datatype,
          tdClass: this.listaInt.indexOf(element.datatype) !== -1 ? 'tdNumeric' : '',
          thClass: this.listaInt.indexOf(element.datatype) !== -1 ? 'tdNumeric' : ''
        })
      })
      this.fields = fieldsCache
    },

    BuscaCampos: function () {
      if (this.listarView.length > 0) {
        this.callConfirm('Deseja iniciar nova consulta?', '').then((result) => {
          if (result.value) {
            this.listandoCamposRelatorio()
          }
        })
      } else {
        this.listandoCamposRelatorio()
      }
    },

    listandoCamposRelatorio: function () {
      this.listarView = []
      this.relatorioItensSelecionado = false
      this.titlePDF = this.relatorioItens.objnome

      this.carregaTexto(this.codeMensagem('C01'))

      axios
        .get(
          this.baseUrlRelatorios +
            'Relatorio/ListaComandosRelatorios?view=' +
            this.relatorioItens.objview,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemColunas = response.data[0].colunas

          if (!this.relatorioItens.objflfiltrobuscar) {
            this.pesquisarRelatorio([])
          } else {
            this.$refs.fccTable.complexFilterShow()
            this.carregaTexto()
          }
        })
        .catch(this.setErrorSystem)
    },
    pesquisarRelatorio: function (listagemFiltro) {
      this.filtroCondicaoCache = listagemFiltro.map((value) => {
        return {
          view: this.relatorioItens.objview,
          campo: value.campo.columnname,
          criterio: value.criterio.valor,
          valor: value.valor,
          condicao: value.condicao.valor === undefined ? '' : value.condicao.valor,
          tipovariavel: value.campo.datatype
        }
      })
      if (this.filtroCondicaoCache.length === 0) {
        this.filtroCondicaoCache.push({
          view: this.relatorioItens.objview,
          campo: '',
          criterio: '',
          valor: '',
          condicao: '',
          tipovariavel: ''
        })
      }
      var listafiltro = this.filtroCondicaoCache

      this.listandoOrder = []
      this.carregaTexto(this.codeMensagem('C01'))
      this.listarView = []
      this.fields = []
      let listaFiltroFinal = {
        nomerelatorio: this.relatorioItens.objnome,
        urlrelatorio: document.location.origin + document.location.pathname + '#/relatorios/listar',
        listafiltro
      }
      this.buscandoRelatorio(listaFiltroFinal)
    },
    pesquisarRelatorioOrdem: function () {
      var listaordenacao = this.listandoOrder.map((value) => {
        return {
          campo: value.campo.columnname,
          tipo: value.tipo.valor
        }
      })
      var listafiltro = this.filtroCondicaoCache
      let listaFiltroFinal = {
        nomerelatorio: this.relatorioItens.objnome,
        urlrelatorio: document.location.origin + document.location.pathname + '#/relatorios/listar',
        listafiltro,
        listaordenacao
      }
      this.buscandoRelatorio(listaFiltroFinal)
    },
    buscandoRelatorio: function (item) {
      this.carregaTexto(this.codeMensagem('C01'))
      this.fields = []
      axios
        .post(
          this.baseUrlRelatorios + 'Relatorio/ListaDinamicaRelatorios',
          item,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.carregaTexto()
          if (response.data.D1?.Relatorio.length > 0) {
            if (response.data.D1.Relatorio[0].hasOwnProperty('@@Mensagem')) {
              this.callAlert(
                'Relatório em processamento',
                response.data.D1.Relatorio[0]['@@Mensagem'],
                'success',
                'success'
              )
              return false
            }

            this.gerandoFields()
            this.listarView = response.data.D1.Relatorio
            this.perPage = this.listarView.length.toString()
            this.relatorioItensSelecionado = true
            this.$root.$emit('bv::hide::modal', 'ordenarCampos')
          } else {
            this.callAlert('Sem resultados', '', 'error', 'error')
          }
        })
        .catch(this.setErrorSystem)
    },
    listandoRelatorio: function () {
      this.carregaTexto(this.codeMensagem('C01'))

      axios
        .get(
          this.baseUrlRelatorios + 'Relatorio/RelatoriosPorToken',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listarRelatorio = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },
  mounted: function () {
    this.baseUrlRelatorios = store.state.baseUrlRelatorios
    this.listandoRelatorio()
  },
  computed: {
    tituloPDF() {
      return this.titlePDF
    }
  }
}
</script>
